import React, { useEffect } from "react";
import { useReward } from "react-rewards";
const REWARD_ID = "confettiReward";
function useGameEndEffect(status) {
    const { reward } = useReward(REWARD_ID, "confetti");
    useEffect(() => {
        if (status === "win") {
            reward();
        }
    }, [reward, status]);
    return {
        id: REWARD_ID,
        className: status === "draw" ? "animate-shake" : "",
    };
}
export const GameStatus = ({ state }) => {
    const { className, ...props } = useGameEndEffect(state.status);
    return (React.createElement("div", { className: "text-xl" },
        React.createElement("span", { ...props, className: `inline-block ${className}` }, statusText(state))));
};
const statusText = (state) => {
    return state.status === "win"
        ? `${state.winner} wins!`
        : state.status === "draw"
            ? "Draw!"
            : `${state.currentPlayer}'s turn`;
};
